module.exports = __webpack_public_path__ + "static/media/chat-double-purple.07d4873b.png";